import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
// Pages
import { Home } from './pages/Home';
import { About } from './pages/About';
import { ProviSystem } from './pages/ProviSystem';
import { Workshop } from './pages/Workshop';
import { ProviSprint } from './pages/ProviSprint';
import { QuarterlyMeeting } from './pages/QuarterlyMeeting';
import { TeamTraining } from './pages/TeamTraining';
import { Contact } from './pages/Contact';
import { FreeResources } from './pages/FreeResources';
import { Masterclass } from './pages/Masterclass';
import { Testimonials } from './pages/Testimonials';
import { Magazin } from './pages/Magazin';
import { ProviToolkit } from './pages/ProviToolkit';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/despremine" element={<About data-id="element-8" />} data-id="element-7" />
            <Route path="/provisystem" element={<ProviSystem data-id="element-10" />} data-id="element-9" />
            <Route path="/provitoolkit" element={<ProviToolkit data-id="element-12" />} data-id="element-11" />
            <Route path="/magazin" element={<Magazin data-id="element-14" />} data-id="element-13" />
            <Route path="/workshop" element={<Workshop data-id="element-16" />} data-id="element-15" />
            <Route path="/provisprint" element={<ProviSprint data-id="element-18" />} data-id="element-17" />
            <Route path="/sedintatrimestriala" element={<QuarterlyMeeting data-id="element-20" />} data-id="element-19" />
            <Route path="/trainingpersonalizat" element={<TeamTraining data-id="element-22" />} data-id="element-21" />
            <Route path="/contact" element={<Contact data-id="element-24" />} data-id="element-23" />
            <Route path="/resursegratuite" element={<FreeResources data-id="element-26" />} data-id="element-25" />
            <Route path="/evenimenteonline" element={<Masterclass data-id="element-28" />} data-id="element-27" />
            <Route path="/testimoniale" element={<Testimonials data-id="element-30" />} data-id="element-29" />
          </Routes>
        </main>
        <Footer data-id="element-31" />
      </div>
    </Router>;
}